export default "__VITE_ASSET__CFQda0sA__"